import { Col, Grid, Row } from "react-bootstrap";
import { classNames } from "react-extras";
import React from "react";
import { MultiStepModal } from "./multi_step_modal";
import Spinner from "../../lib/spinner";
import "./multi_step_modal.scss";
export const MultiStepWithNavContent = ({
  configs,
  pageNumber,
  setPageNumber,
  isEdit,
  isLoading,
}) => {
  if (isLoading) {
    return <Spinner isLoading={isLoading} />;
  }
  return (
    <Grid fluid className={"multistep-nav"}>
      <Row>
        <Col xs={3}>
          {configs.map(({ navOption }, i) => (
            <div
              key={i}
              className={classNames(
                "multistep-nav-item",
                pageNumber === i && "active",
                !isEdit && "disabled"
              )}
              onClick={() => isEdit && setPageNumber(i)}>
              {navOption}
            </div>
          ))}
        </Col>
        <Col xs={7} xsOffset={1}>
          {configs[pageNumber].Content}
        </Col>
      </Row>
    </Grid>
  );
};

export const MultiStepWithNav = ({ configs, commonConfigs, isLoading, ...props }) => {
  const pages = configs.map(config => ({
    ...commonConfigs,
    ...config,
    subTitle: config.subTitle,
    submitText: config.submitText,
    Content: (
      <MultiStepWithNavContent
        isLoading={isLoading}
        isEdit={props.isEdit}
        setPageNumber={props.onUpdatePage}
        configs={configs}
        pageNumber={props.pageNumber}
      />
    ),
  }));
  return (
    <MultiStepModal
      onSubmit={props.onSubmit}
      pages={pages}
      pageNumber={props.pageNumber}
      onUpdatePage={props.onUpdatePage}
      isLoading={props.mediaFileUploadIsLoading}
      close={props.close}
      {...props}
    />
  );
};
